var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("SkeletonTable")
        : _vm.orderStops.length > 0
        ? _c(
            "md-table",
            { staticClass: "context-menu-support" },
            [
              _c(
                "md-table-row",
                [
                  _c("TableHeaderDropdown", {
                    attrs: {
                      "column-icon": "keyboard_arrow_down",
                      "default-text":
                        _vm.tableColumnOptions.columns[
                          _vm.columnKeys.referenceSource
                        ].name,
                      "dropdown-options":
                        _vm.tableColumnKeyOptions.referenceSource,
                      "selected-option":
                        _vm.tableColumnOptions.columns[
                          _vm.columnKeys.referenceSource
                        ],
                    },
                    on: { selectedOption: _vm.handleColumnSwitch },
                  }),
                  _c("md-table-head", { staticClass: "address-container" }, [
                    _vm._v("Address"),
                  ]),
                  _c("md-table-head", [_vm._v("Type")]),
                  _c("md-table-head", [_vm._v("Status")]),
                  _c("md-table-head", [_vm._v("When")]),
                  _c("md-table-head", [_vm._v("Time Window")]),
                  _c("md-table-head", [_vm._v("Assigned To")]),
                  _c("md-table-head", [_vm._v("Duration")]),
                  _c("md-table-head", [_vm._v("Actions")]),
                ],
                1
              ),
              _vm._l(_vm.orderStops, function (stop) {
                return _c(
                  "md-table-row",
                  { key: stop.stopId },
                  [
                    _c(
                      "md-table-cell",
                      { staticClass: "stop-reference" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "ref-link",
                            attrs: {
                              to: {
                                name: "Stop Details",
                                params: { stopId: stop.stopId },
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.tableColumnOptions.columns[
                                    _vm.columnKeys.referenceSource
                                  ].key === "reference-number" ||
                                    stop.sourceReference === null ||
                                    stop.sourceReference === ""
                                    ? stop.stopRef
                                    : stop.sourceReference
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("md-table-cell", { staticClass: "address-container" }, [
                      _c(
                        "div",
                        { staticClass: "custom-ellipsis" },
                        [
                          stop.addressComponents
                            ? _c("GeocodingIndicator", {
                                attrs: {
                                  "address-components": stop.addressComponents,
                                },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n                    " +
                              _vm._s(stop.address || "No address") +
                              "\n                "
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("md-table-cell", [
                      _vm._v(
                        "\n                " +
                          _vm._s(stop.type) +
                          "\n            "
                      ),
                    ]),
                    _c(
                      "md-table-cell",
                      { staticClass: "status-container" },
                      [
                        _c("StopStatusButton", {
                          attrs: { stop: stop },
                          on: {
                            statusHistoryUpdated: function ($event) {
                              return _vm.$emit("statusHistoryUpdated", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c("md-table-cell", { staticClass: "trip-date" }, [
                      stop.tripDate
                        ? _c("div", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    stop.tripDate,
                                    _vm.DATE_TYPES.standardDate
                                  )
                                ) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("md-table-cell", { staticClass: "time-window" }, [
                      stop.timeWindowStart || stop.timeWindowEnd
                        ? _c("div", [
                            stop.timeWindowStart
                              ? _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm._f("dateFormat")(
                                          stop.timeWindowStart,
                                          _vm.DATE_TYPES.standardTime
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ])
                              : _vm._e(),
                            stop.timeWindowStart && stop.timeWindowEnd
                              ? _c("span", [_vm._v("-")])
                              : _vm._e(),
                            stop.timeWindowEnd
                              ? _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm._f("dateFormat")(
                                          stop.timeWindowEnd,
                                          _vm.DATE_TYPES.standardTime
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]),
                    _c(
                      "md-table-cell",
                      [
                        stop.assignedTo
                          ? _c("div", { staticClass: "assigned-column" }, [
                              _c(
                                "div",
                                [
                                  _c("ReassignStopButton", {
                                    attrs: {
                                      type: "text",
                                      item: stop,
                                      "team-members": _vm.teamMembers,
                                      "display-availability-indicator": true,
                                    },
                                    on: {
                                      assignedUser: function ($event) {
                                        return _vm.$emit("assignedUser", $event)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _c("ReassignStopButton", {
                              attrs: {
                                type: "button",
                                item: stop,
                                "team-members": _vm.teamMembers,
                                "display-availability-indicator": true,
                              },
                              on: {
                                assignedUser: function ($event) {
                                  return _vm.$emit("assignedUser", $event)
                                },
                              },
                            }),
                      ],
                      1
                    ),
                    _c("md-table-cell", [
                      _vm._v(_vm._s(stop.duration) + " min"),
                    ]),
                    _c(
                      "md-table-cell",
                      { staticClass: "action-buttons" },
                      [
                        stop.trackingLink
                          ? _c(
                              "md-button",
                              {
                                staticClass: "md-info md-just-icon md-round",
                                attrs: { title: "View Tracking Link" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.$emit(
                                      "trackingLinkClick",
                                      stop.trackingLink
                                    )
                                  },
                                },
                              },
                              [_c("md-icon", [_vm._v("link")])],
                              1
                            )
                          : _vm._e(),
                        stop.hasProofOfDelivery
                          ? _c("StopPdfDownloadButton", {
                              attrs: {
                                "stop-id": stop.stopId,
                                status: stop.status.toLowerCase(),
                                "stop-type": stop.type,
                                "stop-ref": stop.stopRef,
                                "use-icon": true,
                              },
                            })
                          : _vm._e(),
                        _vm.canCloneJobs
                          ? _c("CloneJob", {
                              attrs: {
                                "stop-id": stop.stopId,
                                "stop-details": stop,
                                "use-icon": true,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _c("div", [
            _c("p", { staticClass: "no-result-message" }, [
              _vm._v("No existing stops for this order."),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }